import { createSlice } from "@reduxjs/toolkit";

import { fetchGetRoles, ROLES_FORBIDDEN } from "./actions";
import { DataStatus } from "../../types";

type RolesState = {
  data: UserRole[];
  status: DataStatus;
  error: string | null;
  /** `GET /roles/` answered 403: the principal is not permitted to list roles. */
  forbidden?: boolean;
};

const initialState: RolesState = {
  data: [],
  status: DataStatus.idle,
  error: null,
  forbidden: false,
};

export const Slice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    resetRoles: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetRoles.pending, (state) => {
        state.status = DataStatus.loading;
        state.error = null;
      })
      .addCase(fetchGetRoles.fulfilled, (state, action) => {
        state.status = DataStatus.succeeded;
        state.data = action.payload;
        state.forbidden = false;
      })
      .addCase(fetchGetRoles.rejected, (state, action) => {
        if (action.payload === ROLES_FORBIDDEN) {
          // Not permitted is a settled answer, not a loading failure: the app
          // proceeds with no roles list rather than stalling the global loader.
          state.status = DataStatus.succeeded;
          state.data = [];
          state.forbidden = true;
          return;
        }
        state.status = DataStatus.failed;
        state.error = action.error.message ?? "";
      });
  },
});

export default Slice;
